import React, { useState,useRef, useEffect } from "react";
import Config from "../../config.js"
import Axios from "axios";
import swal from 'sweetalert'
import Typography from '@material-ui/core/Typography';
import ReactHtmlParser from 'react-html-parser';
const EventMessage = React.forwardRef((props, ref) => {
    const {
        refresh ,
        address='ICTChallenge',
        ...rest
    } = props;
    const [message, setMessage] = React.useState(null);
    useEffect(() => {
      Axios.post(Config.api + address+"/GetMessage", {
      },
          {
              headers: {
                  apikey: Config.apikey,
                  Authorization: "Bearer " + localStorage.getItem('token')

              }
          }).then(async (result) => {
            setMessage(result.data.data.Message!=""?result.data.data.Message:"پیامی وجود ندارد.")
          }).catch((err) => {
              if (err&&err.response&&err.response.status&&err.response.status === 401) {
                  localStorage.removeItem('token');
                  props.history.push("/SignIn");
              }
              else if (err&&err.response&&err.response.status&&err.response.status === 422)
                  console.log("اطلاعات ارسالی نادرست است.")
              else if (err&&err.response&&err.response.data&&err.response.data.message&&err.response.data.message.pr) {
                  swal(err.response.data.message.pr);
              }
              else
              console.log("خطایی رخ داده است.")
          })
    },[refresh]);
      return (
        <Typography variant="body2" gutterBottom component="div" display="block" > 
              {ReactHtmlParser(message)}
         </Typography>
      );
});


export default EventMessage;
